import { render, staticRenderFns } from "./dingdAdd.vue?vue&type=template&id=853392e2&scoped=true"
import script from "./dingdAdd.vue?vue&type=script&lang=js"
export * from "./dingdAdd.vue?vue&type=script&lang=js"
import style0 from "./dingdAdd.vue?vue&type=style&index=0&id=853392e2&prod&lang=css"
import style1 from "./dingdAdd.vue?vue&type=style&index=1&id=853392e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853392e2",
  null
  
)

export default component.exports